import { journeyGetJson, journeyPostJson } from 'src/utils/journeyApi';

export const apiValidateOrganizationBySlug = (slug: string) => journeyPostJson(`/api/organizations/validate`, { slug });
export const apiValidateInviteToken = (token: string) => journeyGetJson(`/api/organization-invites/${token}`);
